
















































/**
 * Vista pantalla Login de usuario de satélite
 *
 * ARCHIVO DEFINIDO EN REPOSITORIO CORE, NO SE DEBE MODIFICAR EN SATÉLITES PARTICULARES.
 */

import Vue from 'vue';
import { AUTH_SERVICE, IUserAuth } from '@/services/auth.service';
import { ROLE_COMERCIAL} from '@/app.consts';
import { User } from '@/models/User';
import {
  LAYOUT_MUTATION_MOSTRAR_LOADING,
  LAYOUT_MUTATION_OCULTAR_LOADING
} from '@/store/layout/layout.types';
import { USER_MUTATION_SET_USER } from '@/store/user/index.types';
import { getLogoSrc } from '@/components/brand.consts';
import { trimUsuarioSales } from '../acuerdo-comercial/acuerdo-comercial.helpers';

export default Vue.extend({
  props: {
    hover: { type: Boolean, default: false }
  },
  data() {
    return {
      username: '',
      password: '',
      error_auth: '',
      logo_src: getLogoSrc()
    };
  },
  methods: {
    /**
     * Hookeado a boton iniciar sesión
     * Muestra loading e intenta autenticar contra pool de usuarios de cógnito.
     * Si está OK setea el usuario y redirige a Home, si falla muestra error de autenticación.
     */
    login() {
      this.$store.commit(LAYOUT_MUTATION_MOSTRAR_LOADING);
      let usuario = new User();
      AUTH_SERVICE.loguearse(this.username, this.password)
        .then(async (user: IUserAuth) => {
          usuario.email = this.username;
          let user_sesion = user.getSignInUserSession();
          if (!user_sesion) return;

          const id_token = user_sesion.getIdToken();
          if (!id_token || !id_token.payload || !id_token.payload['cognito:groups'].includes(ROLE_COMERCIAL)) {
            this.error_auth = 'Usuario no posee el rol comercial. Solicitar a soporte.';
            return;
          }

          // Si en el payload existe el nombre, se lo asignó como nombre al usuario sino le asignó el usuario extraido del email.
          usuario.nombre = id_token.payload.name || trimUsuarioSales(usuario.email);

          usuario.token_auth = id_token.getJwtToken();
          this.setAppUser(usuario);

        })
        .catch(() => {
          this.error_auth = 'Usuario/contraseña inválidos. Volvé a intentar.'; // ToDo parametrizar de acuerdo a tipo de error
        })
        .finally(() => this.$store.commit(LAYOUT_MUTATION_OCULTAR_LOADING));
    },

    /**
     * Seteo de usuario a nivel de aplicación, usando store Vuex, y luego redirecciona a Home de satélite
     */
    setAppUser(user: User) {
      this.$store.commit(USER_MUTATION_SET_USER, user);
      this.$router.push('/');
    }
  }
});
